export default "__VITE_ASSET__b2eb5e79__"